import React, { useContext, useEffect } from "react";
import { useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";

import { Modal, Row, Table } from "react-bootstrap";
import { CancelButton } from "../../common/Button";
import {
  formatDate,
  formatDateTime,
  variant_type,
} from "../../../utils/common";
import { getData } from "../../../utils/api";

library.add(fas);

const OrderHistoryModal = (props) => {
  const [data, setData] = useState({});
  const GetSingleData = async (id) => {
    const response = await getData(`/admin/orders/order/${id}`);
    if (response?.success) {
      setData(response?.data);
    }
  };

  useEffect(() => {
    if (props.show) {
      GetSingleData(props.show);
    }
  }, [props.show]);

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Order History
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive">
            <Table striped bordered hover responsive center>
              <thead>
                <tr className="">
                  <th className="sr">Sr. No.</th>
                  <th className="tax-name">Order Status </th>
                  <th className="tax-name">Date </th>
                </tr>
              </thead>
              <tbody>
                {data &&
                  data?.Order_Histories?.length > 0 &&
                  data?.Order_Histories?.map((item, index) => (
                    <tr className="" key={index}>
                      <td>{++index}</td>
                      <td>{item?.Order_status?.name}</td>
                      <td>{formatDateTime(item?.createdAt)}</td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </div>

          <Row className="mt-5 pb-3">
            <div className="d-flex justify-content-center">
              <Link>
                <CancelButton name={"Close"} handleClose={props.handleClose} />
              </Link>
            </div>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default OrderHistoryModal;
